import React, { createContext, useContext, useState, useEffect } from 'react';

const FormContext = createContext();

export const useFormContext = () => {
    const context = useContext(FormContext);
    if (!context) {
        throw new Error('useFormContext must be used within a FormProvider');
    }
    return context;
};

export const FormProvider = ({ children }) => {
    const [formData, setFormData] = useState(() => {
        const savedData = localStorage.getItem('chatbotFormData');
        return savedData ? JSON.parse(savedData) : {};
    });
    const [currentSection, setCurrentSection] = useState(() => {
        const savedSection = localStorage.getItem('chatbotCurrentSection');
        return savedSection ? parseInt(savedSection) : 0;
    });

    useEffect(() => {
        localStorage.setItem('chatbotFormData', JSON.stringify(formData));
    }, [formData]);

    useEffect(() => {
        localStorage.setItem('chatbotCurrentSection', currentSection.toString());
    }, [currentSection]);

    const updateFormData = (newData) => {
        setFormData(prev => ({ ...prev, ...newData }));
    };

    const resetForm = () => {
        localStorage.removeItem('chatbotFormData');
        localStorage.removeItem('chatbotCurrentSection');
        setFormData({});
        setCurrentSection(0);
        window.location.reload(); // Refresh the page to restart the form
    };

    return (
        <FormContext.Provider value={{
            formData,
            updateFormData,
            currentSection,
            setCurrentSection,
            resetForm
        }}>
            {children}
        </FormContext.Provider>
    );
}; 